<template>
    <div class="card-body">
        <div class="card-top">
            <backindex :msg="payMsg"></backindex>
        </div>

        <div class="info-title-pay">
            <div class="left-title">
                <p >{{$t("account")}}：</p>
                <p class="font-name">{{user.username}}</p>
            </div>
            <div class="right-title">
                <p >{{$t("balance")}}：</p>
                <p calss="font-coin">{{user.score}}</p>
                <p>{{$t("coin")}}</p>
            </div>
        </div>

        <p class="pay-cost" v-if="$J.trim(title)!=''">{{title}}</p>
        <p class="pay-cost" v-if="coin>0">{{$t("price")}}：{{coin}}{{$t("coin")}}</p>

        <div class="style-area">
            <p class="style-title">储值方式：</p>
            <mycardpaytype :region="region"></mycardpaytype>
        </div>

        <div class="card-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
    import backindex from "@/components/common/backindex"
    import pagebottom from "@/components/common/pagebottom"
    import mycardpaytype from "@/components/common/mycardpaytype"
    export default {
        name: "card",
        components:{
            backindex,
            pagebottom,
            mycardpaytype
        },
        data(){
            return{
                payMsg:"",
                user:{},
                id: this.$route.query.id?this.$route.query.id:0,
                region:this.$route.query.region?this.$route.query.region:7,
                title:this.$route.query.title?this.$route.query.title:"",
                coin:this.$route.query.coin?this.$route.query.coin:"",
            }
        },
        mounted: function() {
            this.getUser();
            this.payMsg = this.$t("charge");
        },
        methods:{
            getUser:function(){
                this.req.getUser().then(res=>{
                    if(res.data.id>0){
                        this.user = res.data;
                    }else{
                        this.go.goLogin();
                    }
                })
            },
            selectPay(para,num){
                let arr = this.payArr.map((item,index)=>{
                    if(index == num){
                        item.status = true;
                    }else{
                        item.status = false;
                    }
                    this.paynum = item.payCoin;
                    return item;
                });
                this.payArr = arr;
            },
            showBox(para,num){
                let arr = this.payStyle.map((item,index)=>{
                    if(index == num){
                        item.status = true;
                    }else{
                        item.status = false;
                    }
                    return item;
                });
                this.payStyle = arr;
                this.boxShow = false;
                this.storeShow = true;
                this.selectFlag = para.hasStore;
            },
            hideBox(){
                let arr = this.payStyle.map((item,index)=>{
                    item.status = false;
                    return item;
                });
                this.payStyle = arr;
                this.boxShow = true;
            },
            showStore(){
                this.storeShow = !this.storeShow ;
            },
        }
    }
</script>

<style>
  .pay-cost{
        width: 100%;
        padding: 0.4rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
    }
    .card-body{
        width: 100%;
        padding: 1.12rem 0 2.13rem 0;
    }
    .card-top{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
    }
    .card-bottom{
        width: 100%;
        position: fixed;
        left: 0;
        bottom: 0;
    }
    .info-title-pay{
        width: 100%;
        height: 1.12rem;
        border-bottom: 0.02rem solid #e6e6e6;
        box-sizing: border-box;
        padding: 0.36rem 0.4rem 0;
        display: flex;
        justify-content: space-between;
    }
    .save-bottom{
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
    }
    .left-title,.right-title{
        font-size: 0.32rem;
        color: #4d4d4d;
        display: flex;
        font-weight: 700;
    }
    .font-coin{
        color: #ff1f4f;
    }
    .style-area{
        width: 100%;
        height: auto;
        padding: 0.4rem 0 0 0.35rem;
        box-sizing: border-box;
    }
    .style-title{
        font-size: 0.32rem;
        line-height: 0.32rem;
        color: #4c4c4c;
        padding: 0 0 0.56rem 0.05rem;
    }
    .item-area{
        width: 100%;
        height: auto;
        overflow: hidden;
    }
    .style-item{
        width: 1rem;
        height: 1.7rem;
        float: left;
        margin: 0 0.98rem 0.4rem 0;
        text-align: center;
    }
    .style-select{
        border: 0.01rem solid #ff1f4f;
    }
    .style-item:nth-child(4n){
        margin-right: 0;
    }
    .item-img{
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
    }
    .item-img img{
        width: 1rem;
        height: 1rem;
        display: block;
        margin: 0 auto;
    }
    .item-font{
        font-size: 0.24rem;
        line-height: 0.32rem;
        padding-top: 0.1rem;
    }
    .pop-box{
        width: 6.64rem;
        height: 9.5rem;
        background: #ffffff;
        border-radius: 0.08rem;
        box-sizing: border-box;
        box-shadow: 0 0 0.2rem 0 #b4b4b4;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 99;
    }
    .box-top{
        width: 100%;
        height: 1.12rem;
        border-bottom: 0.02rem solid #f2f2f2;
        text-align: center;
        box-sizing: border-box;
        padding-top: 0.4rem;
    }
    .box-top p{
        font-size: 0.3rem;
        color: #ff1f4f;
        font-weight: 700;
    }
    .hide-box{
        position: absolute;
        right: 0.2rem;
        top: 0.2rem;
        width: 0.32rem;
        height: 0.32rem;
    }
    .hide-box img{
        width: 0.32rem;
        height: 0.32rem;
        display: block;
    }
    .box-area{
        width: 100%;
        height: auto;
        padding-top: 0.4rem;
    }
    .coin-select{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.4rem;
    }
    .coin-title{
        font-size: 0.3rem;
        line-height: 0.3rem;
        padding-bottom: 0.4rem;
    }
    /*银行选择*/
    .box-select{
        width: 100%;
        box-sizing: border-box;
        padding: 0 0.4rem 0.4rem;
    }
    .select-area-pay{
        width: 100%;
        height: 0.82rem;
        display: flex;
    }
    .select-title{
        font-size: 0.3rem;
        color: #666666;
        line-height: 0.82rem;
    }
    .store-area{
        width: 4.28rem;
        height: 0.82rem;
        border-radius: 0.08rem;
        box-sizing: border-box;
        border: 0.01rem solid #808080;
        display: flex;
        position: relative;
    }
    .store-left{
        width: 3.78rem;
        height: 0.8rem;
        font-size: 0.3rem;
        color: #808080;
        text-align: center;
        line-height: 0.8rem;
    }
    .store-right{
        width: 0.5rem;
        box-sizing: border-box;
        padding: 0.32rem 0 0 0;
        border-left: 0.01rem solid #808080;
    }
    .store-right img{
        width: 0.18rem;
        height: 0.14rem;
        display: block;
        margin: 0 auto;
    }
    .store-right .right-img{
        -webkit-transform:rotate(180deg);
    }
    .store-right .right-img-select{
        -webkit-transform:rotate(0deg);
    }
    .store-select{
        position: absolute;
        left: -0.01rem;
        top: 0.8rem;
        width: 4.28rem;
        height: 4.8rem;
        box-sizing: border-box;
        border: 0.01rem solid #808080;
        border-top: none;
        overflow-y: auto;
        background: #ffffff;
        z-index: 99;
    }
    .store-item{
        width: 4.26rem;
        height: 0.8rem;
        border-bottom: 0.01rem solid #f2f2f2;
        font-size: 0.28rem;
        line-height: 0.8rem;
        color: #666666;
        text-align: center;
    }
    .store-can-select{
        background: #f2f2f2;
    }
    .store-item:last-child{
        border-bottom: none;
    }
    /*支付选择*/
    .pay-area{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .pay-item{
        width: 2.8rem;
        height: 1.4rem;
        box-sizing: border-box;
        border: 0.01rem solid #cccccc;
        border-radius: 0.08rem;
        position: relative;
        text-align: center;
        font-weight: 700;
        margin-bottom: 0.4rem;
    }
    .item-select{
        border: 0.03rem solid #ff1f4f;
    }
    .area-one{
        font-size: 0.24rem;
        line-height: 0.24rem;
        color: #ff1f4f;
        padding: 0.2rem 0;
    }
    .area-two{
        font-size: 0.2rem;
        line-height: 0.2rem;
        color: #666666;
        padding-bottom: 0.18rem;
    }
    .area-three{
        font-size: 0.22rem;
        line-height: 0.22rem;
        color: #4d4d4d;
    }
    .area-three span{
        color: #ff1f4f;
    }
    .dis-count{
        width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        top: 0;
        right: 0;
    }
    .dis-count img{
        display: block;
        width: 0.8rem;
        height: 0.8rem;
    }
    .dis-num{
        width: 0.8rem;
        font-size: 0.16rem;
        line-height: 0.16rem;
        color: #ffffff;
        position: absolute;
        top: 0.14rem;
        right: -0.14rem;
        transform: rotate(45deg);
        font-weight: 500;
    }
    .pay-btn{
        width: 100%;
        box-sizing: border-box;
        padding: 0 0.2rem;
    }
    .pay-click{
        width: 100%;
        height: 0.84rem;
        font-size: 0.32rem;
        color: #FFFFFF;
        line-height: 0.84rem;
        background: #ff1f4f;
        border-radius: 0.08rem;
        text-align: center;
        font-weight: 700;
    }
    .btn-area{
        width: 100%;
        height: auto;
        padding-top: 0.4rem;
    }
    .pay-btn{
        width: 5.4rem;
        height: 0.8rem;
        border-radius: 0.08rem;
        background: #ff1f4f;
        margin: 0 auto;
        font-size: 0.32rem;
        line-height: 0.8rem;
        font-weight: 700;
        color: #ffffff;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/pay/card.vue